import { render, staticRenderFns } from "./ChooseKhoaHoc.vue?vue&type=template&id=2c899085&"
import script from "./ChooseKhoaHoc.vue?vue&type=script&lang=js&"
export * from "./ChooseKhoaHoc.vue?vue&type=script&lang=js&"
import style0 from "./ChooseKhoaHoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports